module.exports = __webpack_public_path__ + "img/temp_key.600fece0.svg";